export default __webpack_public_path__ + "static/media/download-xvl.df629dc4.png";